import Typography, {
  TypographyProps,
} from '../../../../../../shared/library/Typography';

export interface TitleWithInlineElementProps extends TypographyProps {
  title: string;
}

export default function TitleWithInlineElement(
  props: TitleWithInlineElementProps,
) {
  const { title, variant = 'subtitle1', children, ...titleProps } = props;

  return (
    <Typography variant={variant} {...titleProps}>
      {title}
      {children}
    </Typography>
  );
}
